/* ccs-megamenu-shared.js — matchMedia viewport gate (Phase 2) */
(function () {
  'use strict';
  var DESKTOP_MQ = window.matchMedia('(min-width: 751px)');
  var TOUCH_MQ = window.matchMedia('(pointer: coarse)');

  window.CCSMegaMenu = window.CCSMegaMenu || {};
  var ccs = window.CCSMegaMenu;

  ccs.isDesktop = function () { return DESKTOP_MQ.matches; };
  ccs.isTouch = function () { return TOUCH_MQ.matches; };

  ccs._initDesktop = null;
  ccs._teardownDesktop = null;
  ccs._initMobile = null;
  ccs._teardownMobile = null;

  function syncViewport() {
    if (DESKTOP_MQ.matches) {
      if (typeof ccs._teardownMobile === 'function') ccs._teardownMobile();
      if (typeof ccs._initDesktop === 'function') ccs._initDesktop();
    } else {
      if (typeof ccs._teardownDesktop === 'function') ccs._teardownDesktop();
      if (typeof ccs._initMobile === 'function') ccs._initMobile();
    }
  }

  DESKTOP_MQ.addEventListener('change', syncViewport);
  document.addEventListener('DOMContentLoaded', syncViewport);

  // Cart pulse — Dawn dispatches `cart:refresh` on updates. We listen for both
  // names so the badge animates regardless of which Dawn version is running.
  function pulseCartBadges(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (b) {
      if (typeof count === 'number') b.textContent = count;
      b.classList.remove('pulse');
      void b.offsetWidth;
      b.classList.add('pulse');
    });
  }
  document.addEventListener('cart:update', function (e) {
    var c = e && e.detail && typeof e.detail.count === 'number' ? e.detail.count : undefined;
    pulseCartBadges(c);
  });
  document.addEventListener('cart:refresh', function () {
    pulseCartBadges();
  });
  // Canonical CCS cart pipeline (snippets/ccs-atc.liquid ccsCartDrawerRefresh)
  // dispatches `ccs:cart:updated` with the full /cart.js payload as detail.
  document.addEventListener('ccs:cart:updated', function (e) {
    var detail = e && e.detail;
    if (detail && typeof detail.item_count === 'number') {
      pulseCartBadges(detail.item_count);
      return;
    }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { pulseCartBadges(cart.item_count); })
      .catch(function () { pulseCartBadges(); });
  });
  ccs.pulseCart = pulseCartBadges;

  // Promo strip — simple swap rotator (no fancy animation). Scoped
  // per-container so desktop + mobile cycle independently.
  function setupPromoRotator(container) {
    var slides = container.querySelectorAll('.ccs-mm-promo-slide');
    if (slides.length < 2) {
      // Single slide — just ensure it's visible.
      if (slides[0]) slides[0].hidden = false;
      return null;
    }
    slides.forEach(function (s, i) { s.hidden = i !== 0; });
    var interval = parseInt(container.getAttribute('data-promo-rotate'), 10) || 5000;
    interval = Math.max(2000, interval);
    var i = 0;
    return setInterval(function () {
      if (document.hidden) return;
      slides[i].hidden = true;
      i = (i + 1) % slides.length;
      slides[i].hidden = false;
    }, interval);
  }
  document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('.ccs-mm-promo');
    ccs._promoIntervals = [];
    containers.forEach(function (c) {
      var iv = setupPromoRotator(c);
      if (iv) ccs._promoIntervals.push(iv);
    });
  });

  // Predictive-search: recent searches in localStorage. Saved after the user
  // pauses typing for 1.5s with a meaningful term; rendered as chips in the
  // empty-state block of every predictive-search dropdown on the page.
  var RECENT_KEY = 'ccs_ps_recent';
  var RECENT_MAX = 5;

  function loadRecent() {
    try { return JSON.parse(window.ccsLS.get(RECENT_KEY) || '[]'); }
    catch (_e) { return []; }
  }
  function storeRecent(list) {
    try { window.ccsLS.set(RECENT_KEY, JSON.stringify(list)); } catch (_e) {}
  }
  function saveRecent(term) {
    if (!term || term.length < 3) return;
    var list = loadRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    storeRecent(list.slice(0, RECENT_MAX));
    renderRecent();
  }
  function clearRecent() {
    storeRecent([]);
    renderRecent();
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function renderRecent() {
    var list = loadRecent();
    var blocks = document.querySelectorAll('[data-ccs-ps-recent]');
    blocks.forEach(function (block) {
      if (list.length === 0) { block.hidden = true; return; }
      block.hidden = false;
      var chipsEl = block.querySelector('[data-ccs-ps-recent-chips]');
      if (!chipsEl) return;
      var clockSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="11" height="11" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
      chipsEl.innerHTML = list.map(function (term) {
        return '<a href="/search?q=' + encodeURIComponent(term) +
               '" class="ccs-ps-chip ccs-ps-chip-recent">' + clockSvg +
               '<span>' + escapeHtml(term) + '</span></a>';
      }).join('');
    });
  }
  document.addEventListener('DOMContentLoaded', renderRecent);

  var saveTimer = null;
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'search') return;
    if (!input.closest || !input.closest('predictive-search')) return;
    clearTimeout(saveTimer);
    var term = (input.value || '').trim();
    if (term.length < 3) return;
    saveTimer = setTimeout(function () { saveRecent(term); }, 1500);
  });
  document.addEventListener('click', function (event) {
    var clearBtn = event.target.closest && event.target.closest('[data-ccs-ps-recent-clear]');
    if (!clearBtn) return;
    event.preventDefault();
    event.stopPropagation();
    clearRecent();
  });

  // Predictive-search quick-add-to-cart. Event-delegated because the dropdown
  // markup is injected dynamically by /search/suggest.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-ccs-ps-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.getAttribute('data-state')) return;

    btn.setAttribute('data-state', 'loading');

    /* EXCEPTION to canonical-ATC rule: this is a tiny "+" button whose
       layout can't host CCSLoading's progress-bar fill child. Keep the
       raw fetch + data-state badge UX, but call ccsCartDrawerOpen on
       success so the drawer opens (canonical feedback). */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed (' + res.status + ')');
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (typeof ccs !== 'undefined' && typeof ccs.pulseCart === 'function') {
          ccs.pulseCart(cart.item_count);
        }
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { count: cart.item_count } }));
        if (typeof window.ccsCartDrawerOpen === 'function') {
          window.ccsCartDrawerOpen('Added to cart');
        }
        btn.setAttribute('data-state', 'added');
        setTimeout(function () { btn.removeAttribute('data-state'); }, 1500);
      })
      .catch(function (err) {
        console.error('CCS predictive-search add-to-cart failed:', err);
        btn.removeAttribute('data-state');
      });
  });
})();
